<template>
  <transition name="c-modalMovie">
  <div v-if="isShow" class="c-modalMovie isOpen">
    <div class="c-modalMovie__wrap" :style="setStyleWrap()">
      <iframe v-if="isShow" width="560" height="315" :src="`https://www.youtube.com/embed/${movieID}`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>

    <div class="c-modalMovie__btn">
      <div class="c-modalMovie__close" @click="close">
        <div class="c-modalMovie__closeWrap">
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  </div>
  </transition>
</template>

<script>
  import { assets_path, breakpoint } from '@/_modules/utils/variables';

  export default {
    data() {
      return {
        lang: '',
        ispc: false,
        adjust: {
          pc: {
            h: 170,
            w: 240
          },
          sp: {
            h: 100,
            w: 20
          }
        },
        isShow: false,
        preWidth: 0,
        styleWrap: '',
        movieID: ''
      }
    },
    computed: {
      setStyleWrap: function() {
        return function() {
          return this.styleWrap;
        }
      }
    },
    created() {

    },
    mounted() {
      this.lang = this.$store.getters.getLang;

      if (this.lang === 'ja') {
        this.movieID = 'd6vADs942og';
      } else if (this.lang === 'en') {
        this.movieID = 'kzMVlWtuDZA';
      } else if (this.lang === 'de') {
        this.movieID = 'kzMVlWtuDZA';
      } else if (this.lang === 'fr') {
        this.movieID = 'kzMVlWtuDZA';
      } else if (this.lang === 'it') {
        this.movieID = 'kzMVlWtuDZA';
      } else if (this.lang === 'es') {
        this.movieID = 'kzMVlWtuDZA';
      } else if (this.lang === 'zh-cmn-Hans') {
        this.movieID = 'kzMVlWtuDZA';
      } else if (this.lang === 'zh-cmn-Hant') {
        this.movieID = 'kzMVlWtuDZA';
      } else {
        this.movieID = 'kzMVlWtuDZA';
      }

      this.resize();
      window.addEventListener('resize', this.resize);
    },
    methods: {
      resize() {
        if (!this.isShow) return;

        let imgW = 16, imgH = 9;
        const winW = this.getBodyWidth();
        const winH = window.innerHeight;
        this.windowHeight = winH;

        let adjust = {};
        if (window.innerWidth > breakpoint) {
          this.ispc = true;
          adjust = this.adjust.pc;
        } else {
          this.ispc = false;
          adjust = this.adjust.sp;
        }

        if (this.ispc || this.preWidth !== winW) {
          // ブラウザサイズにフィット
          const bgW = winW - adjust.w;
          const bgH = winH - adjust.h;
          const scale = Math.min(bgW / imgW, bgH / imgH);
          const frameW = imgW * scale;
          const frameH = imgH * scale;
          const frameX = (bgW - frameW) / 2;
          const frameY = (bgH - frameH) / 2;

          this.styleWrap = `height:${frameH}px; width:${frameW}px`;
        }
      },
      open() {
        this.isShow = true;
        this.resize();
      },
      close() {
        this.isShow = false;
      },
      getBodyWidth() {
        return document.body.clientWidth || window.innerWidth;
      }
    }
  }
</script>